import React from "react";
import { MediumImage } from "../../StyledComponents/StyledComponents";
const ResumeButton = (props) => {
  return (
    <div>
      <MediumImage src={props.src} {...props} />
    </div>
  );
};
export default ResumeButton;
